
import Map from 'ol/Map';
import ol_View from 'ol/View';
import ol_layer_Tile from 'ol/layer/Tile';
import * as ol_style from 'ol/style';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import { Vector as ol_layer_Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import VectorImageLayer from 'ol/layer/VectorImage';
import { Point as ol_geom_Point } from 'ol/geom';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';

import { FrLayer } from 'gmap';
import GeoJSON from 'ol/format/GeoJSON';
import GML2 from 'ol/format/GML2';
import GML from 'ol/format/GML';
import * as ol_proj from 'ol/proj';//projections 
import * as ol_extent from 'ol/extent';
import * as ol_loadingstrategy from 'ol/loadingstrategy';
//sources
import ol_source_XYZ from 'ol/source/XYZ';
import ol_source_OSM from 'ol/source/OSM';
import ol_source_WMTS from 'ol/source/WMTS';
import ol_tilegrid_WMTS from 'ol/tilegrid/WMTS';
import ol_source_TileWMS from 'ol/source/TileWMS';
import { mapcte } from 'gmap';
import { MapSupervisionHelper } from './map-supervision-helper';
import { OlObjectTypeEnum, Panel } from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';
import { TimePerf } from 'shtools';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { AppInjector } from 'base-models';
import { Output, EventEmitter, Directive } from '@angular/core';
import { MRectangle } from 'gmap';
import { environment } from '@app-environments/environment';
import { AppConfig } from '@solar/app.config';

/**
 * Class to load site panels
 */
@Directive()
export class MapPanelSourceHelper {

  /**
   * Pattern to configure the panel name
   */
  panel_locator_pattern: string;
  private panelVectorSource: ol_source_Vector;
  private vectorSourceType = "GeoJSON";
  private http: HttpClient;
  private errorcontrolservice: ErrorcontrolService;
  static LAYER_SITE_PANELS='SITE_PANELS';
  /**
   * Event raised when starts and end loading panels
   */
  @Output() loadingEvent: EventEmitter<any> = new EventEmitter();


  private map_extentsearched_prev_resolution = -1;
  private map_extentsearched_prev: any[];
  private map_extentsearched_actual: any[];
  //webWorker: Worker;
  private webworkerlog = "";
  // map:Map;
  constructor(
  ) {
    //   this.map=mapc.map;
    const injector = AppInjector.getInjector();
    if (injector) {
      this.http = injector.get(HttpClient);
      this.errorcontrolservice = injector.get(ErrorcontrolService);
    }
    /*     if (typeof Worker !== 'undefined') {
          this.webWorker = new Worker('./panel-worker.worker', { type: 'module' });
          this.webWorker.onmessage = function (data) {
            
            console.log("Received message:",data);
    
          }
        }
        else{
          console.log("Web worker not admitted");
        } */
  }

  /**
   * Load site panels
   * @param visible 
   * @param minZoom 
   * @param panel_locator_pattern 
   */
  loadSitePanelsMap(visible: boolean = true, minZoom = 17.8, panel_locator_pattern: string): any {
    this.panel_locator_pattern = panel_locator_pattern;
    let cls = this;
    this.panelVectorSource = new ol_source_Vector({
      format: new GeoJSON(),
      //url:cls.wfsURL.bind(this),
      loader: cls.wfsLoader.bind(this),
      strategy: ol_loadingstrategy.bbox,
      overlaps: false
    });

    let layerPanels = new ol_layer_Vector({
      source: this.panelVectorSource,
    });

    layerPanels.getSource().on('addfeature', this.onAddFeature.bind(this));
    layerPanels.setVisible(visible);
    let frlayer= new FrLayer('Site vector panels', MapPanelSourceHelper.LAYER_SITE_PANELS, minZoom);
    frlayer.tooltip="Layer with panels geometry, locator and other info. Due to the volume of data it is only displayed with high zoom.";
    layerPanels[mapcte.frlayerinfo_FieldName] =frlayer;
    
    layerPanels.setMinZoom(minZoom);
    return layerPanels;
  }

  /**
   * Based on total extent get the new extents if exist from previous extent and the new one.
   * @param extent is Y,X,Y,X
   */
  private calcExtents(extent: any[], resolution, projection): any[] {
    //convert to X,Y,X,Y
    //let extent=[openlayers_extent[1] , openlayers_extent[0] , openlayers_extent[3] , openlayers_extent[2]];
    if (this.map_extentsearched_prev_resolution != resolution) {
      //reset actual extent
      this.map_extentsearched_prev = null;
      this.map_extentsearched_actual = null;
    }
    this.map_extentsearched_prev_resolution = resolution;
    let rectPrev = this.getRectangle(this.map_extentsearched_actual);
    //console.log("Rectangle old",rectPrev);
    let rectNew = this.getRectangle(extent);
    //console.log("Rectangle New",rectNew);

    this.map_extentsearched_prev = this.map_extentsearched_actual;
    this.map_extentsearched_actual = extent;
    if (rectPrev == null) {
      return [extent];
    } else {
      //calc intersection
      let rectList = this.calcExtentsIntersection(rectNew, rectPrev);
      let extentList = [];
      for (let ext of rectList) {
        extentList.push(ext.getAsExtent());
      }
      return extentList;
    }

    return [extent];
  }
  /**
   * Calc 2 rectangles from 2 extents
   * @param rectNew 
   * @param rectPrev 
   */
  private calcExtentsIntersection(rectNew: MRectangle, rectPrev: MRectangle): MRectangle[] {
    let rv: MRectangle = new MRectangle();
    let rh: MRectangle = new MRectangle();
    if (rectPrev.left <= rectNew.left) {
      rv.left = rectPrev.right;
      rv.right = rectNew.right;
      rh.left = rectNew.left;
      rh.right = rectNew.right;
    }
    else if (rectPrev.left >= rectNew.left) {
      rv.left = rectNew.left;
      rv.right = rectPrev.left;
      rh.left = rectNew.left;
      rh.right = rectNew.right;
    }
    //top
    if (rectPrev.top <= rectNew.top) {
      rv.top = rectNew.top;
      rv.bottom = rectPrev.bottom;
      rh.top = rectPrev.bottom;
      rh.bottom = rectNew.bottom;
    }
    else if (rectPrev.top >= rectNew.top) {
      rv.top = rectPrev.top;
      rv.bottom = rectNew.bottom;
      rh.top = rectNew.top;
      rh.bottom = rectPrev.top;
    }

    return [rv, rh];
  }

  private getRectangle(extent: any[]): MRectangle {
    if (!extent) {
      return null;
    }
    let x1 = extent[0];
    let y1 = extent[1];
    let x2 = extent[2];
    let y2 = extent[3];

    let rect1: MRectangle = new MRectangle()
    rect1.left = x1;
    rect1.right = x2;
    rect1.top = y1;
    rect1.bottom = y2;

    return rect1;
  }

  /**
   * 
   * @param extent 
   * @param resolution 
   * @param projection 
   */
  private wfsLoader(extent, resolution, projection) {
    //console.log("WFSLoader extent: " + extent[0] + ',' + extent[1] + ',' + extent[2] + ',' + extent[3] + " Resolution:" + resolution);
    this.logExtentAsFeatureCoords(extent);
    let newExtentList: any[] = this.calcExtents(extent, resolution, projection);

    for (let ext of newExtentList) {
      let newExtent: any[] = ext;
      //console.log("WFSLoader NEW extent: " + newExtent[0] + ',' + newExtent[1] + ',' + newExtent[2] + ',' + newExtent[3]);
      this.logExtentAsFeatureCoords(newExtent);
      //WFS need coords as Y,X,Y,X
      let extentAsString = newExtent[1] + ',' + newExtent[0] + ',' + newExtent[3] + ',' + newExtent[2];
      let proj = projection.getCode();
      let GIS_SERVER_URL=AppConfig.gis_configuration.gis_server_url;
      //todo: buscar url correcta
/*       let url = GIS_SERVER_URL + '/cgi-bin/wfs?service=WFS&' +
        'version=1.1.0&request=GetFeature&typename=ms:panel&' +
        'outputFormat=geojson&' +
        'srsname=' + proj + '&' +
        'bbox=' + extentAsString + ',' + proj; */
      
        let url = GIS_SERVER_URL + AppConfig.gis_configuration.gis_base_service_vector_url + '?service=WFS&' +
        'version=1.1.0&request=GetFeature&typename=ms:panel&' +
        'outputFormat=geojson&' +
        'srsname=' + proj + '&' +
        'bbox=' + extentAsString + ',' + proj;

      let prom = this.requestDataToWFSServer(url);
      prom.then(res => this.getDataHandleresult(res));
      prom.catch(res => this.getDataHandleErr(extent));
    }
  }
  /**
   * For debug purposes
   * @param res 
   */
  private logExtentAsFeatureCoords(res: any[]) {
    if (!environment.production) {
      return;
    }
    let s = "[[" + res[0] + "," + res[1] + "],[" + res[2] + "," + res[1] + "],[" + res[2] + "," + res[3] + "],[" + res[0] + "," + res[3] + "],[" + res[0] + "," + res[1] + "]]";
    console.log(s);
  }
  /**
   * No funciona, genera error CORS
   * @param url 
   */
  private getExtentDataFromServer(url): Observable<any> {
    const httpOptions = {
      body: null,
      headers: new HttpHeaders({ 'Sec-Fetch-Site': 'cross-site', 'Sec-Fetch-Mode': 'no-cors' })
    };

    return this.http.get<any>(url, httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`fetched getData url=${url}`)),
      catchError(this.errorcontrolservice.handleError('getData'))
    );
  }

  private requestDataToWFSServer(url: string) {

    let startTime = new Date();
    this.loadingEvent.emit("LOADING");
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      //xhr.onerror = this.getDataHandleErr.bind(this);
      //xhr.onload=this.getXHRHandleresult.bind(this);

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            TimePerf.timeElapsed(startTime, "MakeRequest end");
            resolve(xhr.responseText)
          } else {
            reject(xhr.response)
          }
        }
      }
      xhr.send()
    });
  }

  private getDataHandleresult(res) {
    let s: any = this.panelVectorSource;
    //this.webWorker.postMessage({"vs":s});
    let resp = res;
    let startTime = new Date();
    setTimeout(function () {
      let featCollection = s.getFormat().readFeatures(resp);
      TimePerf.timeElapsed(startTime, "ReadFeatures end");
      startTime = new Date();
      this.onAddFeature_count = 0;
      s.addFeatures(featCollection);
      TimePerf.timeElapsed(startTime, "AddFeatures end");
      //console.log("this.onAddFeature_count= " + this.onAddFeature_count);
      this.loadingEvent.emit("LOADING_END");
    }.bind(this), 0);

  }

  private getXHRHandleresult($event) {
    let s: any = this.panelVectorSource;
    let resp = $event.target.responseText
    let featCollection = s.getFormat().readFeatures(resp);
    s.addFeatures(featCollection);
  }

  private getDataHandleErr(extent) {
    this.panelVectorSource.removeLoadedExtent(extent);
    this.loadingEvent.emit("LOADING_END_ERROR");
  }

  private _featureAddedCount = 0;
  private _onAddFeature_count = 0;
  private onAddFeature(evt) {
    this._onAddFeature_count += 1;
    //evt.feature.getGeometry().transform('EPSG:3857', 'EPSG:4326');
    let featur = evt.feature;
    this.configPanel(featur, this.panel_locator_pattern);
  }


  private async configPanel(featur, panel_pattern) {
    try {
      this._featureAddedCount += 1;
      let values = featur.getProperties();
      let locatorDesc = values.name;//MapSupervisionHelper.locatorGetFormatedDescByPattern(panel, locator_patern);
      const layerExt = new FrLayer(locatorDesc, values.id);
      layerExt.ref = OlObjectTypeEnum.panel;
      featur[mapcte.frlayerinfo_FieldName] = layerExt;
      let panel = new Panel();
      panel.id = values.id;
      panel.id_panel_type = values.id_panel_type;
      panel.name = values.name;


      if (this.vectorSourceType == "GML") {
        panel.locator = JSON.parse(values.locator);
      } else if (this.vectorSourceType == "GeoJSON") {
        panel.locator = values.locator;
      }
      let kk: any = featur.getGeometry();
      let coords: any[] = kk.getCoordinates();
      for (let item of coords[0]) {
        if (item.length == 3) {
          item.splice(2, 1);
        }
      }
      panel.geom = { "type": "Polygon", "coordinates": coords };
      panel.mapLocator = MapSupervisionHelper.locatorGetFormatedDescByPattern(panel, panel_pattern);
      layerExt.refObject = panel;

    } catch (err) {
      console.log(err);
    }

  }

}